import React from 'react';

interface Style {
  displayName?: string;
}

interface TripHotelCardStylesBadgeProps {
  styles: (string | Style)[];
  hotelId?: string | number;
}

/** The purple strip of hotel styles overlaid on the image's bottom edge. */
export default function TripHotelCardStylesBadge({
  styles,
  hotelId,
}: TripHotelCardStylesBadgeProps) {
  if (!styles?.length) return null;

  return (
    <div className="absolute bottom-0 backdrop-blur-sm bg-purple-600 bg-opacity-50 w-full p-2">
      <div className="text-center text-white text-xs">
        {styles.map((style, index) => (
          <span key={hotelId + '' + index}>
            {typeof style === 'string' ? style : style?.displayName}
            {index !== styles.length - 1 && ', '}
          </span>
        ))}
      </div>
    </div>
  );
}
